import { render, staticRenderFns } from "./SecondStepIronPalace.vue?vue&type=template&id=1ce89cbd&scoped=true&"
import script from "./SecondStepIronPalace.vue?vue&type=script&lang=js&"
export * from "./SecondStepIronPalace.vue?vue&type=script&lang=js&"
import style0 from "./SecondStepIronPalace.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SecondStepIronPalace.vue?vue&type=style&index=1&id=1ce89cbd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce89cbd",
  null
  
)

export default component.exports